let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2X7cR")).then(() => parcelRequire('5q8CD'));